module.exports = __webpack_public_path__ + "img/first_right.ac6fefa4.svg";